import { HelpCircle } from 'lucide-react';
import IconTooltip from '@/components/ui/icon-tooltip';

/** The "?" beside a section header: that section's own tip, on hover or tap.
 * It replaces the sentence that used to sit under the heading — six of those
 * down a step read as a form to be filled in rather than a thing to make. */
export default function SectionHelp({
  title,
  body,
}: {
  title: string;
  body: string;
}) {
  return (
    <IconTooltip
      label={title}
      description={body}
      className="text-muted-foreground/60 transition-colors hover:text-primary"
    >
      <HelpCircle className="h-4 w-4" />
    </IconTooltip>
  );
}
